module.exports = __webpack_public_path__ + "static/img/icon-acn-3.472f83db.png";